import { popupBus, PopupBusEventsKeysEnum } from "./bus";
import { PopupsEnum } from "./popups";
import { IAuthPopupProps } from "components/UI/Popups/AuthPopup";
import { IAddToNichePopupProps } from "components/niches/AddToNichePopup";
import { IReportPopupProps } from "components/UI/Popups/Report";
import { IAddToCollectionPopupProps } from "components/UI/Popups/Collections";
import { IEditNichePopupContainerProps } from "components/popups/EditNichePopup";
import { IEditNichesDialogProps } from "components/dialogs/EditNichesDialog";
import { IGifPreferencePopupProps } from "components/UI/Popups/GifPreferencePopup";
import { IShareGifMenuProps } from "components/UI/ShareMenu";
import { IMoreMenuContainerProps } from "components/popups/MoreMenu";

export const onOpenPreferencesPopup = () => {
  popupBus.emit(PopupBusEventsKeysEnum.OpenEventKey, { name: PopupsEnum.Preferences });
};

export const onClosePreferencesPopup = () => {
  popupBus.emit(PopupBusEventsKeysEnum.CloseEventKey, { name: PopupsEnum.Preferences });
};

export const onOpenChangedEmailPopup = () => {
  popupBus.emit(PopupBusEventsKeysEnum.OpenEventKey, { name: PopupsEnum.ChangedEmail });
};

export const onCloseChangedEmailPopup = () => {
  popupBus.emit(PopupBusEventsKeysEnum.CloseEventKey, { name: PopupsEnum.ChangedEmail });
};

export const onOpenAuthPopup = (props: IAuthPopupProps = {}) => {
  popupBus.emit(PopupBusEventsKeysEnum.OpenEventKey, { name: PopupsEnum.Auth, ...props });
};

export const onCloseAuthPopup = () => {
  popupBus.emit(PopupBusEventsKeysEnum.CloseEventKey, { name: PopupsEnum.Auth });
};

export const onOpenAddNichePopup = (props: IAddToNichePopupProps) => {
  popupBus.emit(PopupBusEventsKeysEnum.OpenEventKey, { name: PopupsEnum.AddNiche, ...props });
};

export const onCloseAddNichePopup = () => {
  popupBus.emit(PopupBusEventsKeysEnum.CloseEventKey, { name: PopupsEnum.AddNiche });
};

export const onOpenReportPopup = (props: IReportPopupProps) => {
  popupBus.emit(PopupBusEventsKeysEnum.OpenEventKey, { name: PopupsEnum.Report, ...props });
};

export const onCloseReportPopup = () => {
  popupBus.emit(PopupBusEventsKeysEnum.CloseEventKey, { name: PopupsEnum.Report });
};

export const onOpenAddCollectionPopup = (props: IAddToCollectionPopupProps) => {
  popupBus.emit(PopupBusEventsKeysEnum.OpenEventKey, { name: PopupsEnum.AddCollection, ...props });
};

export const onCloseAddCollectionPopup = () => {
  popupBus.emit(PopupBusEventsKeysEnum.CloseEventKey, { name: PopupsEnum.AddCollection });
};

export const onOpenEditNichePopup = (props: IEditNichePopupContainerProps) => {
  popupBus.emit(PopupBusEventsKeysEnum.OpenEventKey, { name: PopupsEnum.EditNiche, ...props });
};

export const onCloseEditNichePopup = () => {
  popupBus.emit(PopupBusEventsKeysEnum.CloseEventKey, { name: PopupsEnum.EditNiche });
};

export const onOpenEditGifNichesPopup = (props: IEditNichesDialogProps) => {
  popupBus.emit(PopupBusEventsKeysEnum.OpenEventKey, { name: PopupsEnum.EditGifNiches, ...props });
};

export const onCloseEditGifNichesPopup = () => {
  popupBus.emit(PopupBusEventsKeysEnum.CloseEventKey, { name: PopupsEnum.EditGifNiches });
};

export const onOpenEditGifPreferencesPopup = (props: IGifPreferencePopupProps) => {
  popupBus.emit(PopupBusEventsKeysEnum.OpenEventKey, { name: PopupsEnum.EditGifPreferences, ...props });
};

export const onCloseEditGifPreferencesPopup = () => {
  popupBus.emit(PopupBusEventsKeysEnum.CloseEventKey, { name: PopupsEnum.EditGifPreferences });
};

export const onOpenShareGifMenu = (props: IShareGifMenuProps) => {
  popupBus.emit(PopupBusEventsKeysEnum.OpenEventKey, { name: PopupsEnum.ShareGif, ...props });
};

export const onCloseShareGifMenu = () => {
  popupBus.emit(PopupBusEventsKeysEnum.CloseEventKey, { name: PopupsEnum.ShareGif });
};

export const onOpenMoreMenu = (props: IMoreMenuContainerProps) => {
  popupBus.emit(PopupBusEventsKeysEnum.OpenEventKey, { name: PopupsEnum.MoreMenu, ...props });
};

export const onCloseMoreMenu = () => {
  popupBus.emit(PopupBusEventsKeysEnum.CloseEventKey, { name: PopupsEnum.MoreMenu });
};

export const onOpenCookieNotice = () => {
  popupBus.emit(PopupBusEventsKeysEnum.OpenEventKey, { name: PopupsEnum.CookieNotice });
};

export const onCloseCookieNotice = () => {
  popupBus.emit(PopupBusEventsKeysEnum.CloseEventKey, { name: PopupsEnum.CookieNotice });
};
